import { Injectable } from '@angular/core';
import { Payment } from '../models/payment';
import { BehaviorSubject } from 'rxjs';
import { ApiProviderService } from './api-provider.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentServiceService {

  // Propriétés des paiements des clients aux coachs
  private paymentsSubject = new BehaviorSubject<Payment[]>([]);
  payments$ = this.paymentsSubject.asObservable();
  public upcomingPaymentsSubject = new BehaviorSubject<Payment[]>([]);
  upcomingPayments$ = this.upcomingPaymentsSubject.asObservable();
  public completedPaymentsSubject = new BehaviorSubject<Payment[]>([]);
  completedPayments$ = this.completedPaymentsSubject.asObservable();

  // Propriété pour le widget Last Payment
  private lastPaymentsSubject = new BehaviorSubject<Payment[]>([]);
  public lastPayments$ = this.lastPaymentsSubject.asObservable();

  public currentPage = 1;
  public pageSize = 10;
  public isLastPage = false;
  
  constructor(
    private apiProviderService: ApiProviderService,
    private userService: UserService
  ) {
    this.getPayments(this.userService.user.id);
    this.getLastPayments(this.userService.user.id);
  }

  updatePayments(updatedPayments: Payment[], position : string = "end"): void {
    let payments = [];
    
    if(position == "end"){
      payments = [...this.paymentsSubject.getValue(), ...updatedPayments]
    }else{
      payments = [ ...updatedPayments, ...this.paymentsSubject.getValue()]
    }

    this.paymentsSubject.next(payments);
    this.filterPayments(payments);
    //this.getLastPayments(this.userService.user.id);
  }

    updateExistingPayments(updatedPayments: Payment[], position : string = "end"): void {
    
      for(let updatedPaiement of updatedPayments){
        let find = this.paymentsSubject.getValue().find( p => p.id == updatedPaiement.id);
        if(find){
          find = updatedPaiement;
        }
      }

      this.paymentsSubject.next(this.paymentsSubject.getValue());
      this.filterPayments(this.paymentsSubject.getValue());
    //this.getLastPayments(this.userService.user.id);
  }

  // Filtrer les paiements en fonction du type
  filterPayments(payments: Payment[]): void {
    const upcomingPayments = payments.filter(payment => payment.type === 1);
    const completedPayments = payments.filter(payment => payment.type === 0);
    this.upcomingPaymentsSubject.next(upcomingPayments);
    this.completedPaymentsSubject.next(completedPayments);
  }

  // PAYMENTS DES CLIENTS AUX COACHS
  getPayments(coachId: string) : Promise<Payment[]>{
    return new Promise((resolve, reject) => {
    this.apiProviderService.getPaymentsByCoach(coachId, this.currentPage, this.pageSize).subscribe(
      (res) => {
        if(res.length > 0){
          this.updatePayments(res);
          resolve(res)
        }else{
          this.isLastPage = true;
          resolve(res)
        }

      },
      (err) => {
        console.error('Error fetching payments:', err);
        reject();
      }
    );
    })

  }

  async deletePayment(payment: Payment) {
    this.apiProviderService.deletePayment(payment).subscribe(
      () => {
          let index = this.paymentsSubject.getValue().findIndex( p => p.id == payment.id);
          if(index >= 0){
            this.paymentsSubject.getValue().splice(index, 1);
          }
        

        this.paymentsSubject.next(this.paymentsSubject.getValue());
        this.filterPayments(this.paymentsSubject.getValue());
      },
      (err) => {
        console.error('Error deleting payment:', err);
      }
    );
  }

  // Last Payment Subject
  getLastPayments(coachId: string): void {
    this.apiProviderService.getLastPaymentsByCoach(coachId).subscribe(
      (res) => {
        this.lastPaymentsSubject.next(res);
      },
      (err) => {
        console.error('Error fetching last payments:', err);
      }
    );
  }

  validUpcomingPayment(payment : Payment){

    this.apiProviderService.editPayment(payment).subscribe(
      (res) => {
        let payments : Array<Payment> = [];
        payments.unshift(payment);
        this.updateExistingPayments(payments, "start");
      },
      (err) => {
        console.error('Error fetching last payments:', err);
      }
    );
  }

}
